import { Box, Image, useColorModeValue } from "@chakra-ui/react";
import React, { useState } from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";

import { COMMON_ALT } from "../../constant";
import { stylesConfig } from "../../helpers/stylesConfig";

const LazyImage = ({
  src,
  alt,
  className,
  fetchPriority,
  onError,
  isPromotion,
  style,
  isNormalImage,
}) => {
  const [loaded, setLoaded] = useState(false);

  const bgColor = useColorModeValue("#8213f0", "dark.100");

  // useEffect(() => {
  //   setTimeout(() => {
  //     setLoaded(true);
  //   }, 500);
  // }, []);
  // CommonLoading isLoaded={loaded}

  return isNormalImage ? (
    <Image
      src={src}
      alt={alt}
      onError={onError}
      fetchpriority={fetchPriority}
      className={`${className}`}
      style={style}
    />
  ) : (
    <>
      <LazyLoadImage
        src={src}
        alt={alt}
        onLoad={() => {
          setLoaded(true);
        }}
        onError={onError}
        fetchpriority={fetchPriority}
        className={`${className}`}
        style={style}
      />
      {!loaded && (
        <Box
          position="absolute"
          top="0px"
          left="0px"
          bg={bgColor}
          zIndex={0}
          w="100%"
          h="100%"
          display={`flex`}
          alignItems={`center`}
          justifyContent={`center`}
          borderTopRadius={`common`}
        >
          <Image
            src={stylesConfig.mainLogo}
            cursor={"pointer"}
            w="120px"
            objectFit={`cover`}
            mb={isPromotion && "100px"}
            pointerEvents={"all"}
            alt={COMMON_ALT}
            filter="grayscale(100%)"
          />
        </Box>
      )}
    </>
  );
};

export default React.memo(LazyImage);
